import { render, staticRenderFns } from "./organization-configuration.vue?vue&type=template&id=2a3d9a8c&scoped=true"
import script from "./organization-configuration.vue?vue&type=script&lang=js"
export * from "./organization-configuration.vue?vue&type=script&lang=js"
import style0 from "./organization-configuration.vue?vue&type=style&index=0&id=2a3d9a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d9a8c",
  null
  
)

export default component.exports